export default __webpack_public_path__ + "static/media/news-children.2359597f.png";